import React, { Component } from "react";
import { connect } from "react-redux";
import { config } from "../../_config/_config";
import { Navbar } from "react-bootstrap";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.setNavExpanded = this.setNavExpanded.bind(this);
  }
  setNavExpanded(expanded) {
    this.setState({ navExpanded: expanded });
  }
  render() {
    // Construct image src properly
    const imageSrc = config.assetUrl
      ? `${config.assetUrl}${config.assetUrl.endsWith('/') ? '' : '/'}${config.assetBrandName}_logo.png`
      : `/${config.assetBrandName}_logo.png`;

    // Construct header background image URL
    const headerBgImage = config.assetUrl
      ? `${config.assetUrl}${config.assetUrl.endsWith('/') ? '' : '/'}${config.assetBrandName}_header_image.jpg`
      : `/${config.assetBrandName}_header_image.jpg`;

    const headerTopStyle = {
      backgroundImage: `url(${headerBgImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center top',
      backgroundColor: '#050903'
    };

    const navbarStyle = {
      backgroundColor: '#000000',
      background: '#000000'
    };

    return (
      <div className="outer_application_form">
        <header id="header">
          <section className="header-top" style={headerTopStyle}>
            <div className="wrapper">
              <div className="container">
                <a href={config.mainUrl} title="Firestorm" className="logo">
                  <img className="main_logo" src={imageSrc} alt={config.assetBrandName || "Firestorm"} />
                </a>
                <div className="contact-section">
                  <a
                    href={config.mainUrl + "/contact/"}
                    className="buttons "
                  >
                    Contact Us
                  </a>
                  <a href={config.mainUrl + "/about/"} className="buttons ">
                    About Us
                  </a>
                  <a
                    href={config.baseUrl + "/login"}
                    className="icon-emplogin buttons"
                  >
                    Employee Login
                  </a>
                </div>
              </div>
            </div>
          </section>

          <Navbar
            inverse={true}
            onToggle={this.setNavExpanded.bind(this)}
            expanded={this.state.navExpanded}
            style={navbarStyle}
          >
            <Navbar.Header>
              <Navbar.Toggle />
            </Navbar.Header>
            {config.showLogo && (
              <Navbar.Collapse>
                <ul className="nav navbar-nav">
                  <li>
                    <a href={config.mainUrl}>Home</a>
                  </li>
                  <li>
                    <a href={config.mainUrl + "/forestry/"}>Forestry</a>
                  </li>
                  <li>
                    <a href={config.mainUrl + "/fire-safety/"}>Fire Safety</a>
                  </li>
                  <li>
                    <a href={config.mainUrl + "/emergency/"}>Emergency</a>
                  </li>
                  <li>
                    <a href={config.mainUrl + "/training/"}>Training</a>
                  </li>
                </ul>
              </Navbar.Collapse>
            )}
          </Navbar>
        </header>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(Header);
export { connectedApp as Header };
